function isValidDate(date) {
    return date instanceof Date && !isNaN(date) && date?.getFullYear() > 1900;
}

export default isValidDate;